<!--
 * @Author: wufei
 * @Date: 2020-08-13 14:07:20
 * @LastEditTime: 2020-08-18 16:37:40
 * @Description:
 * @FilePath: \mobile-revive\src\views\report\reviveReport\menu.vue
-->
<template>
  <div class="report-menu">
    <div class="item" :class="{active:cur === 'basic'}" @click="switchMenu('basic')">基本信息</div>
    <div class="item" :class="{active:cur === 'first'}" @click="switchMenu('first')">首开复盘</div>
    <div v-if="isObtains" class="item" :class="{active:cur === 'month'}" @click="switchMenu('month')">月度复盘</div>
  </div>
</template>

<script>
export default {
    name: 'ReportMenu',
    props: {
        cur: {
            type: String,
            default: ''
        },
        isObtains: {
            type: Number,
            default: 0
        }
    },
    watch: {
        isObtains(newVal) {
            this.isObtains = newVal
        }
    },
    methods: {
        switchMenu(type) {
            this.$emit('switchMenu', type)
        }
    }
}
</script>

<style lang="scss" scoped>
  .report-menu{
    height:1rem /* 100/100 */;
    display:flex;
    background: white;
    border-top:.01rem /* 1/100 */ solid #DDDDDD;
    border-bottom:.01rem /* 1/100 */ solid #DDDDDD;
    .item{
      flex:1;
      text-align: center;
      line-height:.9rem;
      color:rgba(51,51,51,1);
      font-size:.32rem /* 32/100 */;
    }

    .active {
      color:rgba(39,97,255,1);
      position: relative;
    }

    .active:after {
      content:'';
      display:'inline-block';
      width:.5rem /* 50/100 */;
      height:.06rem /* 6/100 */;
      background:rgba(39,97,255,1);
      border-radius: .03rem /* 3/100 */;
      position: absolute;
      left:50%;
      bottom:0;
      transform: translateX(-50%);
    }
  }
</style>
